import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    try {
      const token = localStorage.getItem('token');
      const usr = localStorage.getItem('usuario');
      if (token && usr) {
        setUsuario(JSON.parse(usr));
      }
    } catch(e) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
    } finally {
      setCargando(false);
    }
  }, []);

  const login = (token, usr) => {
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(usr));
    setUsuario(usr);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, cargando, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);